import React from 'react';

import Box from '../../../../../common/components/Box/Box';
import { DataTable } from '../../../../../common/components';
import { TableHeaderColumn } from 'react-bootstrap-table';
import formatDate from '../../../../../helpers/formatDate';

const Announcements = ({}) => {
  const formatContent = (sections) => <div>{`${sections.preview}`}</div>;

  return (
    <>
      <Box>
        <DataTable
          source="contents"
          name="announcements"
          showTotal
          autoFilters={[
            { type: 'filter[template.type]', value: 'announcement' },
            { type: 'active', value: true },
          ]}
        >
          <TableHeaderColumn dataField="id" isKey hidden />
          <TableHeaderColumn
            width={'15%'}
            dataField="created_at"
            dataFormat={formatDate}
            dataSort
          >
            Created Date
          </TableHeaderColumn>
          <TableHeaderColumn
            width={'85%'}
            dataField="sections"
            dataFormat={formatContent}
          >
            Content
          </TableHeaderColumn>
        </DataTable>
      </Box>
    </>
  );
};

export default Announcements;
